export default __webpack_public_path__ + "static/media/bi_slash.a5d64c1a.svg";